import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import { useState, useCallback, useEffect } from 'react';
import { faturaAPI } from '../../features/fatura/faturaAPI';
import {
  CALCULADA_STATUS,
  CONFERIDA_STATUS,
  LIBERADA,
} from '../../utils/general/operations/operationUtils';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';
import QCXAutocompleteSelectWithSearch from '../autocomplete-select/QCXAutocompleteSelectWithSearch';

function diDescription(di) {
  return `${di?.atributosAdicionais?.processo || ''}`;
}

function filterDi(list) {
  return (list || []).filter((di) => (
    di?.calculada === CALCULADA_STATUS
    && di?.atributosAdicionais?.conferida === CONFERIDA_STATUS
    && di?.atributosAdicionais?.liberada === LIBERADA
    && di?.atributosAdicionais?.registro
  ));
}

const filterOptions = createFilterOptions({
  stringify: (option) => diDescription(option),
});

export default function QCXSelectDeclaracaoImportacaoDanfeAutocomplete({
  label,
  name,
  initialValues,
  disabled,
  ...restProps
}) {
  const [options, setOptions] = useState([]);
  const [defaultValue, setDefaultValue] = useState(null);
  const [emptyListMsg, setEmptyListMsg] = useState('');

  const valorAtual = _.get(initialValues, name);

  // Quando desabilitado (modo consulta/filhote), busca o DI pelo ID para exibição
  useEffect(() => {
    if (!disabled || !valorAtual) return;

    faturaAPI.fetchById(valorAtual)
      .then((res) => {
        if (res?.data) {
          setDefaultValue(res.data);
        }
      })
      .catch(() => {});
  }, [disabled, valorAtual]);

  // Quando habilitado, atualiza o defaultValue conforme seleção na lista de resultados
  useEffect(() => {
    if (disabled) return;
    const found = options.find((item) => String(item?.id) === String(valorAtual));
    setDefaultValue(found || null);
  }, [options, valorAtual, disabled]);

  const handleSearch = useCallback(async (value) => {
    const term = String(value || '').trim();

    if (!term) {
      setOptions([]);
      setEmptyListMsg('');
      return;
    }

    try {
      const response = await faturaAPI.fetchByFilter([
        { name: 'tipo', value: 'DI_DUIMP' },
        { name: 'processo', value: term },
      ]);

      if (response?.status === 200) {
        const filtered = filterDi(response.data || []);
        setOptions(filtered);
        setEmptyListMsg(filtered.length ? '' : 'Nenhum processo encontrado');
      }
    } catch {
      setEmptyListMsg('Erro ao buscar processos');
    }
  }, []);

  if (disabled) {
    return (
      <QCXAutocompleteSelect
        label={label}
        id={name}
        name={name}
        options={defaultValue ? [defaultValue] : []}
        filterOptions={filterOptions}
        defaultValue={defaultValue}
        getOptionValue={(option) => option?.id}
        getOptionLabel={(option) => diDescription(option)}
        disabled
        {...restProps}
      />
    );
  }

  return (
    <QCXAutocompleteSelectWithSearch
      label={label}
      id={name}
      name={name}
      options={options}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionValue={(option) => option?.id}
      getOptionLabel={(option) => diDescription(option)}
      onEventActionPaiFunction={handleSearch}
      emptyListMsg={emptyListMsg}
      placeholder="Digite parte do número do processo para buscar"
      {...restProps}
    />
  );
}
